import React from "react";
import { useState } from "react";
import { pages } from "../config";
import { ShowPageContext } from "./MyContexts";

export default function ShowPageProvider(props: { children: React.ReactNode }) {
  const [showPage, setShowPage] = useState<string>(pages[0].id);

  return (
    <ShowPageContext.Provider value={{ showPage, setShowPage }}>
      {props.children}
    </ShowPageContext.Provider>
  );
}
